import LinkUI from '../../../components/Buttons/LinkUI';
import { Subdimensiones } from '../../../interfaces/Evaluations'

interface ISubdimensionLink {
    selected_type_indicator: { name: string; id: number };
    selected_dimension: { name: string; id: number } | null;
    period: string;
    value: string;
    subdimension: Subdimensiones;
    right: string;
    rightId: string;
    disabled?: boolean;
    className?: string;
    title?: string;
}

const SubdimensionLink = ({
    selected_dimension,
    selected_type_indicator,
    period,
    value,
    subdimension,
    right,
    rightId,
    disabled,
    className,
    title
}: ISubdimensionLink) => {

    const isDisabled = disabled ?? ((subdimension?.indicadores?.length ?? 0) === 0);
    const href = `/monitor/visualizador-de-indicadores?rightId=${rightId}&type=${selected_type_indicator.name}&dimensionID=${selected_dimension?.id}&subdimensionID=${subdimension.id}&period=${period}&page=1&limit=5&filterApplied=true`;

    const handleClick = () => {
        if (isDisabled) return;

        const previousData = {
            path: "/evaluador",
            right: `${right}`,
            rightId: `${rightId}`,
            periodo: `${period}`,
            typeIndicator: `${selected_type_indicator.name}`,
            typeIndicatorId: `${selected_type_indicator.id}`,
            dimension: `${selected_dimension?.name}`,
            dimensionId: `${selected_dimension?.id}`,
            label: 'Volver al Evaluador',
            scrollTargetId: 'table-evaluation-indicator-type'
        };

        sessionStorage.setItem("previous", JSON.stringify(previousData));
    };

    return (
        <LinkUI href={href} disabled={isDisabled} onClick={handleClick} title={title ?? ''} className={className}>
            {value}
        </LinkUI>
    );
}

export default SubdimensionLink